
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gfTiHTTntiha4sfLQnh2I1Yb0aT_455cq0jv9jWEUhAnWoMeta } from "/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index3zvjH_45B7ryY6eWEOKns16Q9CJZ9ZBBSScUPsAibSackMeta } from "/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchOCsdcQrcd_U3MWzEGPa4xskmRTPOiCHiTuG21sHnW_QMeta } from "/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index_45dg1sJDAgQSGo3XdOE_45pPJd61rk_4561QgHF6ddXQAypEMeta } from "/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_938zGzeHWMDMN3mmMe32u8a_45Ye0YWemxM6RKm9duazkQMMeta } from "/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexL0NW35k4qtTAXLsmMNL3IuEzV6rn_GhE3U7vIwi8Oy4Meta } from "/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93eIK4K2KTTw80VcRAsFX6k_45erFeQhPiYFAb_iHjmPu40Meta } from "/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexPyE4GM_AHU_zciWe6vR4jZFsLv4zytyrgnYcE0RAXZQMeta } from "/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93nUUG7aVnHSBUmz9obm1YCEUEiaxBoKuk0MRxs1Pn0jAMeta } from "/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexTcxU_pExWUuDGYZrj5ADM61P7tSyDOpdbz8NxPWp_45_UMeta } from "/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexa32kkxQA6oANBpYtCG5nWQv_45k7IV_6xOy7EkK_451ydcQMeta } from "/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexL0NW35k4qtTAXLsmMNL3IuEzV6rn_GhE3U7vIwi8Oy4Meta || {},
    component: () => import("/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexPyE4GM_AHU_zciWe6vR4jZFsLv4zytyrgnYcE0RAXZQMeta || {},
    component: () => import("/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexTcxU_pExWUuDGYZrj5ADM61P7tSyDOpdbz8NxPWp_45_UMeta || {},
    component: () => import("/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexa32kkxQA6oANBpYtCG5nWQv_45k7IV_6xOy7EkK_451ydcQMeta || {},
    component: () => import("/codebuild/output/src3636132194/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]